<template>
  <section class="position-relative">
    <div
      class="position-relative justify-content-center upload-file-class"
      @mouseenter="isLaptop ? handleMouseEnter() : null"
      @mouseleave="isLaptop ? handleMouseLeave() : null"
      @click="handleContainerClick"
    >
      <input
        class="inputclass"
        ref="propic"
        type="file"
        @input="uploadProfileImage"
        accept="image/*"
        :style="(!isLaptop && imagePath !== null) ? 'pointer-events: none;' : ''"
      />
	
      <img
        v-if="inputData !== null"
        class="profile-pic position-absolute"
        :src="inputData"
        alt="Profile Picture"
      />
     
      <img
        v-if="imagePath != null"
        class="profile-pic-edit position-absolute"
        src="@/assets/newdesign/dashboard/newUploadModal/profile_edit.svg"
        alt="Edit Icon"
      />
	   <img
	   	v-else
        class="profile-pic-placeholder position-absolute"
        src="@/assets/newdesign/dashboard/newUploadModal/upload-dp.svg"
        alt="Upload Profile Picture"
      />

      <div class="candash-select" v-if="showRemoveReplace">
        <div @click="triggerFileInput">
          <label
            for="fileInput"
            class="d-flex align-items-center uploadDocs-caution-font p-2 pl-4 pr-4 pointer"
          >
            <img
              class="ml-1 mr-2"
              src="@/assets/newdesign/dashboard/replace-circle.svg"
              alt=""
            />
            Replace
          </label>
        </div>
        <div
          @click.stop="removeImage"
          class="d-flex align-items-center uploadDocs-caution-font p-2 pl-4 pr-4 pointer"
        >
          <img
            class="mr-1"
            src="@/assets/newdesign/dashboard/delete-bin.svg"
            alt=""
          />
          Remove
        </div>
      </div>

      <div
        class="candash-tooltip"
        v-else-if="!isProfilePictureUploaded && imagePath == null && isLaptop"
      >
        <div class="d-flex align-items-center asp-small-txt text-center">
          Upload your profile picture <br />
          (png, jpg, jpeg) max 2mb
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { deleteImage } from "@/utils/apiFunctions.js";
import toast from "../mixin/toast";
import EventBus from "@/utils/EventBus";
export default {
  name: "ProfilePictureUpload",
  data() {
    return {
      isProfilePictureUploaded: false,
      updateImage: false,
      inputData: null,
      showRemoveReplace: false,
      removeImages: false,
      imagePath: null,
    };
  },
  mixins: [toast],

  props: {
    noLabel: Boolean,
    disabled: Boolean,
    type: String,
    label: String,
    mandatory: Boolean,
    placeholder: String,
    id: String,
    showError: Boolean,
    isImageNull: Boolean,
    newObject: Object,
    checImgPath: String,
    isLaptop: Boolean,
    vmodel: {
      validator: function () {
        return true;
      },
    },
  },
  watch: {
    vmodel(newValue) {
      if (newValue && newValue instanceof File) {
        const reader = new FileReader();
        reader.onload = () => {
          this.inputData = reader.result; // base64 string
        };
        reader.readAsDataURL(newValue);
      } else {
      	this.inputData = newValue;
      }
    },
  },
  created() {
    if (this.vmodel) {
      this.inputData = this.vmodel;
    }
    this.imagePath = this.checImgPath;
  },
  mounted() {
    EventBus.$on("replace-photo", this.triggerFileInput);
    EventBus.$on("delete-photo", this.removeImage);
  },
  beforeDestroy() {
    EventBus.$off("replace-photo");
    EventBus.$off("delete-photo");
  },

  methods: {
    handleContainerClick(event) {
      if (!this.isLaptop && this.imagePath !== null) {
        event.stopPropagation();
        this.openReplaceRemove();
      }
    },
    openReplaceRemove() {
      EventBus.$emit("open-replace-remove");
    },
    handleMouseEnter() {
      if (this.imagePath || this.isProfilePictureUploaded) {
        this.showRemoveReplace = true; // Show only on mouse enter
      }
    },
    handleMouseLeave() {
      this.showRemoveReplace = false; // Hide only on mouse leave
    },
    triggerFileInput() {
      this.$refs.propic.click();
    },
    async uploadProfileImage(event) {
      let inputs = event.target;
      if (inputs.files && inputs.files[0]) {
        const file = inputs.files[0];
        const size = inputs.files[0].size;
        const fileSizeInMb = size / (1024 * 1024);
        if (fileSizeInMb > 2) {
          this.errorModal(
            "Upload failed",
            "Please upload an image with size less than 2MB"
          );
          return;
        }
        const validTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!validTypes.includes(file.type)) {
          this.errorModal(
            "Upload failed",
            "Please upload an image in JPG, JPEG, or PNG format"
          );
          return;
        }
        let reader = new FileReader();
        reader.onload = () => {
          this.inputData = reader.result;
        };
        reader.readAsDataURL(inputs.files[0]);
		this.inputData = inputs.files[0]
        this.imagePath = inputs.files[0];
        this.$emit("select-value", this.inputData);
        this.updateImage = true;
        this.$emit("updateImage", this.updateImage);
        this.isProfilePictureUploaded = true;
      }
      event.target.value = "";
    },
    async removeImage() {
      this.updateImage = true;
      const { firstName, lastName } = this.newObject;
      if (firstName.length === 0 || lastName.length === 0) {
        this.errorModal("Error", "Please provide first name and last name");
        return;
      }
      try {
        const response = await deleteImage(firstName[0] + lastName[0]);
        if (response.status === 200) {
          this.inputData = response.data.data.link;
          this.$emit("select-value", this.inputData);
          this.updateImage = true;
          this.$emit("updateImage", this.updateImage);
          this.removeImages = true;
          this.$emit("remove-image", this.removeImages);
          this.isProfilePictureUploaded = false;
          this.showRemoveReplace = false;
          this.imagePath = null;
        } else {
          this.errorModal("Error", "Something went wrong");
        }
      } catch (error) {
        this.errorModal("Error", "Something went wrong");
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.upload-file-class {
  position: relative;
  width: 95px;
  height: 95px;
  cursor: pointer;
}

.inputclass {
  opacity: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 25;
  cursor: pointer;
}

.profile-pic{
  border-radius: 50%;
  width: 95px;
  height: 95px;
  object-fit: cover;
  position: relative;
  z-index: 1;
}
.profile-pic-placeholder {
  position: absolute;
  bottom: 0px;
  right: 0px;
  z-index: 15;
}
.profile-pic-edit {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 20;
}
</style>